import { QueryClientProvider } from '@tanstack/react-query'
import { useEffect, type ReactNode } from 'react'
import { Toaster } from 'sonner'
import { TooltipProvider } from '@/components/ui/tooltip'
import { applyTheme, useUiStore } from '@/stores/ui'
import { queryClient } from './query-client'

function ThemeSync() {
  const theme = useUiStore((s) => s.theme)

  useEffect(() => {
    applyTheme(theme)
    if (theme !== 'system') return
    const media = window.matchMedia('(prefers-color-scheme: dark)')
    const onChange = () => applyTheme('system')
    media.addEventListener('change', onChange)
    return () => media.removeEventListener('change', onChange)
  }, [theme])

  return null
}

export function Providers({ children }: { children: ReactNode }) {
  const theme = useUiStore((s) => s.theme)

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider delayDuration={250}>
        <ThemeSync />
        {children}
        <Toaster
          position="bottom-right"
          theme={theme}
          // Long enough to read a whole message (the default is 4 seconds).
          duration={7000}
          toastOptions={{
            classNames: {
              toast: '!rounded-lg !border-border !bg-surface-raised !text-ink !shadow-pop !font-sans',
              description: '!text-ink-muted',
            },
          }}
        />
      </TooltipProvider>
    </QueryClientProvider>
  )
}
